//Display Variant B

<template>
	<div class="feature-container">
		<div class="landing-red light-text feature-headline">
			<div class="feature-text-container">	
				{{feature.headline}}
			</div>
		</div>
		<div class="feature-text-container">
			<div class="feature-desc-short content-subtext light-text">
				{{feature.descShort}}
			</div>
			<div class="feature-desc-long content-description light-text">
				{{feature.descLong}}
			</div>
			
			<div v-if="feature.imageDisplay == undefined || feature.imageDisplay == 'firstImage'" class="images-container">
				<div class="image-wrapper">
					<img :src="baseUrl + feature.images[0].url" class="feature-image">
				</div>
			</div> 

			<div v-if="feature.imageDisplay == 'stackFromTop'" class="images-container">
				<div class="image-wrapper stacking-wrapper" v-for="img in feature.images" :key="img.id" >
					<img :src="baseUrl + img.url" :style="{zIndex: compIndexTopFirst(img.id)}" class="feature-image">
				</div>
			</div>

			<div v-if="feature.imageDisplay == 'stackFromBottom'" class="images-container">
				<div class="image-wrapper stacking-wrapper" v-for="img in feature.images" :key="img.id" >
					<img :src="baseUrl + img.url" :style="{zIndex: compIndexBottomFirst(img.id)}" class="feature-image">
				</div>
			</div> 
		</div>
	</div>
</template>

<script>
		export default {
			Name: 'FeatureVariantTwo',
			
			props: {
				feature: {type:Object},
				baseUrl: String,
			},
			
			methods: {
				compIndexTopFirst(key) {
					return 1000 - this.feature.images.findIndex(img => img.id == key);
				},
				
				compIndexBottomFirst(key) {
					return 1000 + this.feature.images.findIndex(img => img.id == key);
				},

			}
		}
		
</script>

<style scoped>
	.feature-container {
		align-items: center;
		display: flex;
		flex-direction: column;
		margin-bottom: 0px;
		width: 60%;
	}

	.feature-text-container {
		display: grid;
		margin: auto;
	}

	.feature-desc-long {
		text-align: right;		
		display: inline-block;
	}
	
	@media (max-width: 991px) {
		.feature-container {
			width: 80%;
		}
	}

	@media (min-width: 768px) {
	
	.feature-headline {
		float: right;
		text-align: right;
		max-width: 100%;
		
	}
	
	.feature-desc-short {
		float: right;
		text-align: right;
	}
}




</style>

